import React from 'react';
import PropTypes from 'prop-types';

import IconWrapper from '../IconWrapper';
import styles from '../search.module.scss';

function HamburgerClose(props) {
  const {
    showMobileMenu,
    searching,
    toggleSearching,
    toggleMobileMenu
  } = props;

  const icon = showMobileMenu || searching ? 'close' : 'hamburgerRebrand';
  const onClick = searching ? () => toggleSearching(false) : () => toggleMobileMenu(!props.showMobileMenu);

  return (
    <IconWrapper
      icon={icon}
      onClick={onClick}
      className={styles['hamburger-close-icon']}
    />
  );
}

HamburgerClose.propTypes = {
  showMobileMenu: PropTypes.bool,
  toggleMobileMenu: PropTypes.func,
  searching: PropTypes.bool,
  toggleSearching: PropTypes.func,
};

export default HamburgerClose;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Search/HamburgerClose/index.js